import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormFactor } from '../../hooks/useWidth'
import { Box, Stack, Typography, Toolbar } from '@mui/material'
import { StatusCodes } from 'http-status-codes'
import { DroopyPlant } from '../../components/Illustrations'

export interface FullScreenErrorProps {
  status?:
    | StatusCodes.NOT_FOUND
    | StatusCodes.UNAUTHORIZED
    | StatusCodes.FORBIDDEN
    | StatusCodes.TOO_MANY_REQUESTS
}

export const FullScreenError: FC<FullScreenErrorProps> = ({ children, status }) => {
  const { t } = useTranslation('uiFullScreenError')
  const { isMobile } = useFormFactor()

  return isMobile ? (
    <>
      <Toolbar />
      <Stack p={2} direction="row" spacing={2} justifyContent="space-between">
        <Box>
          <Typography variant="h4">{t('title', { context: status })}</Typography>
          <Typography variant="h6">{t('description', { context: status })}</Typography>
          {children}
        </Box>
        <Box py={1}>
          <DroopyPlant height={145} width={100} preserveAspectRatio="xMaxYMax" />
        </Box>
      </Stack>
    </>
  ) : (
    <>
      <Toolbar />
      <Stack p={3} direction="row" spacing={3} justifyContent="space-between">
        <Box>
          <Typography variant="h1">{t('title', { context: status })}</Typography>
          <Typography variant="h4">{t('description', { context: status })}</Typography>
          {children}
        </Box>
        <DroopyPlant />
      </Stack>
    </>
  )
}
